import { BACKEND_DOMAIN } from "utils/constants";

export interface BulkEquipmentUploadStatusResponse {
    batch_id: string;
    total_buildings: number;
    completed: number;
    failed: number;
    status: "processing" | "completed";
}

const getBulkEquipmentUploadStatus = async (
    batchId: string,
    accessToken: string
): Promise<BulkEquipmentUploadStatusResponse> => {
    const response = await fetch(
        `${BACKEND_DOMAIN}/sandbox/bulk-equipment-upload/${batchId}/status`,
        {
            headers: { Authorization: `Bearer ${accessToken}` },
        }
    );
    if (!response.ok) throw new Error(`Error: status: ${response.status}`);
    return response.json();
};

export default getBulkEquipmentUploadStatus;
